


















import {
  EstatisticaLeadService,
  ResultadoPorTipoLead,
} from "@/services/estatistica-lead.service";
import ChartDoughnut from "@/shared/components/chart-doughnut.vue";
import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import { tipoLead } from "../../filters/filters";

const colors: { [key: number]: string } = {
  0: "#ab248b",
  1: "#3fa9f5",
  2: "#00c486",
  3: "#ff0000",
  4: "#38499c",
  5: "#83cf00",
};

@Component({
  filters: {
    tipoLead,
  },
  components: {
    ChartDoughnut,
  },
})
export default class GraficoRankingTipoLead extends Vue {
  loading = false;
  legenda = {
    title: "" as string | number,
    value: "" as string | number,
  };
  dados: ResultadoPorTipoLead[] | null = null;
  @Prop({ required: true }) readonly data!: string;

  readonly options: Chart.ChartOptions | Chart.ChartLineOptions = {
    legend: {
      display: false,
    },
  };

  get labels(): string[] {
    return (
      (this.dados && this.dados.map((tipo) => tipoLead(tipo.idTipoLead))) || []
    );
  }

  get dataSet(): Chart.ChartDataSets[] {
    return (
      (this.dados && [
        {
          backgroundColor: this.dados.map((_, i) => colors[i % 6]),
          data: this.dados.map((tipo) => tipo.quantidade),
        },
      ]) ||
      []
    );
  }

  @Watch("data", { immediate: true })
  async fetchDados() {
    this.loading = true;
    try {
      this.dados = await EstatisticaLeadService.resultadoPorTipo(
        moment(`${this.data}-01`).toDate()
      );
    } finally {
      this.loading = false;
    }
  }

  @Watch("dados")
  onValueChange() {
    const dado = this.dados && this.dados[0];
    if (dado) {
      this.legenda.title = dado.idTipoLead;
      this.legenda.value = dado.quantidade;
    }
  }
}
